<template>
  <div class="extend_list_box">
    <van-tabs
      class="extend_list_tabs"
      sticky
      v-model="params.typeId"
      offset-top="11.733333vw"
      @change="tabsChange"
    >
      <van-tab v-for="(i, index) in tabList" :title="i" :key="index">
        <van-list
          class="list-box"
          v-model="loading"
          :finished="finished"
          :error="error"
          :offset="0"
          :immediate-check="false"
          :finished-text="list.length > 0 ? '加载完毕' : ''"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <div v-if="loading || list.length > 0">
            <div class="ts-list" v-if="params.typeId === 0">
              <TsItem
                class="ts-item"
                v-for="item in list"
                :key="item.id"
                :title="item.goodsName"
                :cover="item.albumPics"
                :price="item.goodsPrice"
                :isExtend="true"
                :extendPrice="item.highestReturn"
                @click.native="toDetail(params.typeId, item.id)"
              />
            </div>
            <div v-if="params.typeId === 1">
              <XshyItem
                class="hy-list-item"
                v-for="item in list"
                :key="item.id"
                :title="item.goodsName"
                :cover="item.albumPics"
                :beginTime="
                  item.meetingStartTime
                    .slice(0, 10)
                    .replace(RegExp('-', 'g'), '.')
                "
                :address="item.province + '-' + item.city"
                :type="item.meetingState"
                :price="item.goodsPrice | priceFormat"
                :open="item.open"
                :showType="true"
                :isExtend="true"
                :extendPrice="item.highestReturn"
                @click.native="
                  toDetail(params.typeId, item.meetingId, item.id, item.open)
                "
              />
            </div>
            <div v-if="params.typeId === 2">
              <PxItem
                class="px-list-item"
                v-for="item in list"
                :key="item.id"
                :cover="item.albumPics"
                :title="item.goodsName"
                :price="item.goodsPrice"
                :saleType="item.isFree"
                :author="item.shopName"
                :number="item.nums"
                :isExtend="true"
                :extendPrice="item.highestReturn"
                @click.native="toDetail(params.typeId, item.id)"
              />
            </div>
            <div v-if="params.typeId === 3">
              <BgItem
                class="px-list-item"
                v-for="item in list"
                :key="item.id"
                :cover="item.albumPics"
                :title="item.goodsName"
                :price="item.goodsPrice"
                :isExtend="true"
                :extendPrice="item.highestReturn"
                @click.native="toDetail(params.typeId, item.id)"
              />
            </div>
          </div>
          <noneList noneType="bgList" v-else />
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import TsItem from "@/views/mobileView/components/listItem/tsItem.vue";
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "ExtendMarket",
  components: {
    noneList,
    TsItem,
    XshyItem,
    PxItem,
    BgItem,
  },
  data() {
    return {
      tabList: ["图书", "会议", "课程", "行业报告"],
      params: {
        pageNum: 1,
        pageSize: 10,
        typeId: 0,
      },
      list: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getList();
  },
  filters: {
    priceFormat(priceList) {
      if (priceList.length > 1) {
        return `¥${priceList[0]}-${priceList[priceList.length - 1]}`;
      } else {
        return priceList[0] > 0 ? "¥" + priceList[0] : "免费";
      }
    },
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNum += 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      let obj = this.$global.deepClone(this.params);
      obj.typeId++;
      const res = await this.$apis.extendServe.getExtendMarketList(obj);
      if (res.resultCode === "200") {
        console.log(res, "res");
        this.list.push(...res.data.data);
        this.finished = this.list.length >= +res.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    tabsChange(name) {
      this.params.pageNo = 1;
      this.params.typeId = name;
      this.finished = false;
      this.list = [];
      this.getList();
    },
    // 点击进入详情页
    toDetail(type, id, goodsId, open) {
      switch (type) {
        case 0:
          this.$router.push({
            name: "bookDetails",
            query: { id, goodsId },
          });
          break;
        case 1:
          window.open(
            this.$global.meetingH5Url +
              `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
                open ? "&open=" + open : ""
              }`,
            "_self"
          );
          break;
        case 2:
          this.$router.push({
            name: "courseDetails",
            query: { type: 9, goodsId: id },
          });
          break;
        case 3:
          this.$router.push({
            name: "ReportDetails",
            query: { id },
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.extend_list_box {
  .extend_list_tabs {
    &::v-deep .van-tabs__wrap {
      height: 45px;

      .van-tabs__nav {
        padding-bottom: 13px;

        .van-tab__text {
          font-size: 15px;
          color: #333;
        }

        .van-tab--active {
          .van-tab__text {
            color: #4a79f1;
          }
        }

        .van-tabs__line {
          width: 20px;
          background-color: #4a79f1;
        }
      }
    }
  }

  .list-box {
    width: 100%;
    margin: 12px 0;
    padding: 0 12px;

    .ts-list {
      width: 100%;
      column-count: 2;
      column-gap: 1em;

      .ts-item {
        box-sizing: border-box;
        -webkit-column-break-inside: avoid;
        break-inside: avoid;
        //   max-height: 200px;
        margin-bottom: 24px;
      }
    }

    .hy-list-item {
      margin: 12px auto;
      padding-bottom: 15px;
      width: 351px;
      // height: 275px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
    }

    .px-list-item {
      display: inline-block;
      margin-bottom: 12px;
      margin-right: 10px;
      width: 170px;
      border-radius: 6px;
      background-color: #fff;
      overflow: hidden;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>
